import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { ALG_BUTTONS } from "../../feature-buttons";

export const pageConfigArbeitslosengeld: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.ContactAgencyOrQuestionsAboutArbeitslosengeld),
    welcome: {
        text: getWelcomeText("ALG"),
        disclaimer: DISCLAIMER,
        buttons: ALG_BUTTONS,
    },
};
